import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../axiosInstance';
import { useCommonVars } from './useCommonVars';

const TOKEN_OPTIONS = {
  USDT: { label: 'USDT', networks: ['TRC-20', 'ERC-20', 'BEP-20', 'TON'] },
  TON: { label: 'TON', networks: ['Toncoin'] },
  TRX: { label: 'TRX', networks: ['TRC-20'] },
};

export default function WithdrawPage() {
  const navigate = useNavigate();
  const [method, setMethod] = useState(null);
  const [bank, setBank] = useState('');
  const [phone, setPhone] = useState('');
  const [card, setCard] = useState('');
  const [token, setToken] = useState('USDT');
  const [network, setNetwork] = useState(TOKEN_OPTIONS.USDT.networks[0]);
  const [wallet, setWallet] = useState('');
  const [amount, setAmount] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { minWithdraw } = useCommonVars();
  const [toast, setToast] = useState('');

  const showToast = (message) => {
    setToast(message);
    window.history.replaceState({}, document.title);
    setTimeout(() => setToast(''), 4000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    setIsSubmitting(true);

    const normalizedAmount = amount.replace(',', '.');
    const amountValue = parseFloat(normalizedAmount);

    const minValue = method === 'crypto' ? 500 : minWithdraw;

    if (isNaN(amountValue) || amountValue < minValue) {
      showToast(
        method === 'crypto'
          ? `❌ Минимальная сумма вывода криптовалютой: 500₽`
          : `❌ Минимальная сумма вывода: ${minWithdraw}₽`
      );
      setIsSubmitting(false);
      return;
    }

    const payload = {
      amount: amountValue,
      method,
      bank_name: method === 'sbp' ? bank : '',
      account_number:
        method === 'sbp' ? phone
        : method === 'card' ? card
        : method === 'crypto' ? wallet
        : method === 'payeer' ? wallet
        : '',
      crypto_network: method === 'crypto' ? network : '',
      comment: '',
    };

    try {
      await axios.post('/withdrawal-request/', payload, { withCredentials: true });
      navigate('/card', {
        state: { confirmMessage: "✅ Заявка успешно отправлена!" }
      });
    } catch (error) {
      const errMsg = error.response?.data?.detail || "❌ Ошибка при отправке заявки";
      showToast(errMsg);
    } finally {
      setTimeout(() => setIsSubmitting(false), 2000);
    }
  };

  return (
    <div className="withdraw-page">
      {toast && (
        <div className="toast-wrapper">
          <div className="toast-inner">{toast}</div>
        </div>
      )}
      <div className="withdraw-panel">
        <div className="header">
          <h2>Вывести средства</h2>
          <button
            className="close-btn"
            onClick={() => navigate('/card')}
          >
            ×
          </button>
        </div>
        <div className="method-label-top">Выберите способ вывода средств</div>
        <div className="tabs">
          <button
            className={`tab ${method === 'card' ? 'active' : ''} card-tab`}
            onClick={() => setMethod('card')}
          >
            <span className="tab-label">
              Карта
              <span className="bolt-animated">
                <svg width="22" height="22" viewBox="0 0 20 20" fill="none">
                  <defs>
                    <linearGradient id="bolt-gradient" x1="0" y1="0" x2="20" y2="20" gradientUnits="userSpaceOnUse">
                      <stop stopColor="#fff200"/>
                      <stop offset="1" stopColor="#fedc2a"/>
                    </linearGradient>
                  </defs>
                  <path
                    d="M10 2 L4 11 H9 L8 18 L16 8 H11 L12 2 Z"
                    fill="url(#bolt-gradient)"
                    stroke="#fffbe4"
                    strokeWidth="1.2"
                  >
                  </path>
                </svg>
              </span>
            </span>
          </button>
          <button
            className={`tab ${method === 'sbp' ? 'active' : ''}`}
            onClick={() => setMethod('sbp')}
            style={{ display: 'none' }}
          >
            СБП
          </button>
          <button
            className={`tab ${method === 'crypto' ? 'active' : ''}`}
            onClick={() => setMethod('crypto')}
          >
            Криптовалюта
          </button>
          <button
            className={`tab ${method === 'payeer' ? 'active' : ''}`}
            onClick={() => setMethod('payeer')}
          >
            Payeer
          </button>
        </div>
        <div className="subheader">
          <p>Выплаты осуществляются круглосуточно.</p>
          <small>Максимальное время обработки заявки - 24 часа.</small>
        </div>
        {method && (
          <form className="form" onSubmit={handleSubmit}>
            {method === 'card' && (
              <>
                <div className="fast-pay-label">Быстрые выплаты по данному направлению</div>
                <input
                  type="text"
                  placeholder="Номер карты (16 цифр)"
                  value={card}
                  onChange={e => setCard(e.target.value)}
                  required
                />
              </>
            )}
            {method === 'sbp' && (
              <>
                <input
                  type="text"
                  placeholder="Название банка"
                  value={bank}
                  onChange={e => setBank(e.target.value)}
                  required
                />
                <input
                  type="tel"
                  placeholder="Телефон получателя"
                  value={phone}
                  onChange={e => setPhone(e.target.value)}
                  required
                />
              </>
            )}
            {method === 'crypto' && (
              <>
                <div className="select-group">
                  <select
                    value={token}
                    onChange={e => {
                      setToken(e.target.value);
                      setNetwork(TOKEN_OPTIONS[e.target.value].networks[0]);
                    }}
                  >
                    {Object.entries(TOKEN_OPTIONS).map(([key, opt]) => (
                      <option key={key} value={key}>{opt.label}</option>
                    ))}
                  </select>
                  <select
                    value={network}
                    onChange={e => setNetwork(e.target.value)}
                  >
                    {TOKEN_OPTIONS[token].networks.map(net => (
                      <option key={net} value={net}>{net}</option>
                    ))}
                  </select>
                </div>
                <input
                  type="text"
                  placeholder="Адрес кошелька"
                  value={wallet}
                  onChange={e => setWallet(e.target.value)}
                  required
                />
              </>
            )}
            {method === 'payeer' && (
              <>
                <input
                  type="text"
                  placeholder="Payeer кошелёк (например, P1234567)"
                  value={wallet}
                  onChange={e => setWallet(e.target.value)}
                  required
                />
              </>
            )}
            <input
              type="tel"
              inputMode="decimal"
              placeholder="Сумма вывода"
              value={amount}
              onChange={e => {
                const input = e.target.value
                  .replace(/[^0-9,]/g, '')
                  .replace(/,+/g, ',')
                  .replace(/^,/, '')
                  .replace(/(,\d*),/g, '$1');
                setAmount(input);
              }}
              onPaste={e => e.preventDefault()}
              onDrop={e => e.preventDefault()}
              required
            />
            <div className="actions">
              <button
                type="submit"
                className="btn confirm"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Отправка..." : "Подтвердить"}
              </button>
              <button
                type="button"
                className="btn cancel"
                onClick={() => setMethod(null)}
              >
                Отмена
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}






